import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import BlueButton from "../BlueButton/BlueButton.js";
import Loader from "../BlueButton/Loader.js";
import CheckboxFilter from "../CheckboxFilter.js";
import CustomDropdown from "./CustomDropdown.js";
import {Autocomplete, TextField} from "@mui/material";
import Api from "../../Api.js";
import {REACT_APP_API_URL} from "../../config.js";
import {withStyles,} from '@mui/styles';
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import {useParams} from "react-router-dom";
import {accountantRequest, taskCompanyRequest, taskManagerRequest} from "../../store/actions/task.js";

const ValidationTextField = withStyles({
    root: {
        '& input:valid + fieldset': {
            borderColor: '#63c0ba',
            borderWidth: 2,
        },
        '& input:invalid + fieldset': {
            borderColor: 'red',
            borderWidth: 2,
        },
        '& input:valid:focus + fieldset': {
            borderColor: '#63c0ba',
            borderLeftWidth: 6,
            padding: '4px !important', // override inline-style
        },
    },
})(TextField);

function EditRepeatedTask({show, onHide, copy, data}) {
    const login = useSelector((state) => state.manager.employee);
    const dispatch = useDispatch()
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);
    const [limitData, setLimitData] = useState({
        organization: [],
        taskTemplate: [],
        manager: [],
        stuff: [],
        repeated_type: [
            {name: "daily", value: 1},
            {name: "weekly", value: 2},
            {name: "monthly", value: 3},
            {name: "annual", value: 4}
        ]
    });
    const [template, setTemplate] = useState(true);
    useEffect(() => {
        (async () => {
            const {data} = await Api.taskTemplate()
            setTemplate(data)

        })();
    }, []);


    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    useEffect(() => {
        (async () => {
            setLimitData({
                organization: companies.map(s => ({
                    ...s,
                    value: REACT_APP_API_URL + 'manager-company/' + s.id + '/',
                    url: REACT_APP_API_URL + 'manager-company/' + s.id + '/'
                })),
                taskTemplate: template.results,
                manager: managers,
                repeated_type: [
                    {name: "daily", value: 1},
                    {name: "weekly", value: 2},
                    {name: "monthly", value: 3},
                    {name: "annual", value: 4}
                ],
                stuff: account.map(s => ({
                    value: s.id,
                    url: REACT_APP_API_URL + 'accountant/' + s.id + '/', ...s,
                    label: s.user.first_name + ' ' + s.user.last_name
                }))
            })
        })()
    }, [companies, managers, account, template])

    const _getValue = (obj, key) => obj?.[key] ?? "";
    const _getRepeatedTypeByNumber = (num) => {
        const types = {
            1: "daily",
            2: "weekly",
            3: "monthly",
            4: "annual"
        };
        return types[num] || "";
    };

    const [visibleForClient, setVisibleForClient] = useState(data ? _getValue(data, "visible_for_client") : true);
    const [images, setImages] = useState([]);
    const [active, setActive] = useState(data ? _getValue(data, "is_active") : true);
    const formInit = [
        {
            key: 'company',
            value: data ? _getValue(data, "company") : "",
            option: "organization",
            errorMessage: "select_error",
            type: "dropDown",
            label: _getValue(data, "company_name"),
            valid: true,
        },
        {
            key: localStorage.getItem("profession") === "manager" ? 'accountant' : "manager",
            value: data ? _getValue(data, 'accountant') : "",
            option: localStorage.getItem("profession") !== "accountant" ? "stuff" : "manager",
            errorMessage: "select_error",
            type: "dropDown",
            label: data ? `${_getValue(data, "accountant_first_name")} ${_getValue(data, "accountant_last_name")}` : "",
            valid: true
        },
        {
            key: 'name',
            value: data ? _getValue(data, "name") : "",
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'text',
            value: data ? _getValue(data, "text") : "",
            errorMessage: "empty_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'duration',
            value: data ? _getValue(data, "duration") : null,
            errorMessage: "respective_error",
            type: "number",
            label: "",
            valid: true
        },
        {
            key: 'repeated_type',
            value: data ? _getValue(data, "repeated_type") : "",
            errorMessage: "empty_error",
            type: "dropDown",
            option: 'repeated_type',
            label: data ? _getRepeatedTypeByNumber(_getValue(data, "repeated_type")) : "",
            valid: true
        },
        {
            key: 'repeated_value',
            value: data ? _getValue(data, "repeated_value") : "",
            errorMessage: "respective_error",
            type: "number",
            label: "",
            valid: true
        },
    ];

    const [form, setForm] = useState(formInit);
    const getSelected = (array, name) => {
        if (!Array.isArray(array)) return;

        return array.find(element => {
            if (!name) {
                return (
                    (element.user?.last_name === data?.accountant_last_name &&
                        element.user?.first_name === data?.accountant_first_name) ||
                    element.url === data?.manager
                );
            } else {
                return element.name === name;
            }
        });
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSubmit(); // Replace with your actual submit function
        }
    };
    const getRepeatedType = () => {
        const repeatedTypeField = form.find(f => f.key === "repeated_type");
        return repeatedTypeField?.value;
    };
    const setIntervalValid = (min, max, value) => {
        const num = parseInt(value, 10);
        return num >= min && num <= max;
    };
    const handleChange = (e, item, index) => {
        e.preventDefault();
        const updatedForm = [...form];
        const value = e.target.value;
        updatedForm[index].value = value;

        let valid = false;

        if (item.type === "number") {
            const repeatedType = getRepeatedType();

            if (item.key === "duration") {
                valid = value > 0 && value.length < 4;
            } else if (repeatedType === 2) {
                valid = setIntervalValid(1, 7, value);
            } else if (repeatedType === 3) {
                valid = setIntervalValid(1, 31, value);
            } else if (repeatedType === 4) {
                valid = setIntervalValid(1, 366, value);
            }
        } else if (item.type === "text") {
            valid = value.length > 0;
        }

        updatedForm[index].valid = valid;
        setForm(updatedForm);
    };
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskManagerRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    const handleSubmit = async () => {
        const profession = localStorage.getItem("profession");
        const id_task = data?.id;
        const url = login?.url;

        setSubmitted(true);
        setDisabled(true);

        const shouldSkipLast = parseInt(form[5]?.value, 10) === 1;
        const loopLength = shouldSkipLast ? form.length - 1 : form.length;

        const formData = new FormData();

        for (let i = 0; i < loopLength; i++) {
            const field = form[i];
            if (!field.valid) {
                setDisabled(false);
                return;
            }
            formData.append(field.key, field.value);
        }

        formData.append(profession, url);
        formData.append("is_active", active);
        formData.append("visible_for_client", visibleForClient);

        try {
            if (copy) {
                formData.append("creator", login?.user?.url);
                await Api.createRepeatedTask(formData)
            } else {
                await Api.editRepeatedTask(id_task, formData)
            }
            SuccessToast()
            await onHide()
        } catch (error) {
            setDisabled(false);
            ErrorToast()
        }
    };
    const renderInputField = (item, index) => {
        const repeatedType = getRepeatedType(); // assumes this helper exists

        // Skip rendering if repeated_type === 1 and this is 'repeated_value'
        if (repeatedType === 1 && item.key === "repeated_value") return null;

        return (
            <div className="input-validation" key={index}>
                <TextField
                    type={item.type}
                    variant="outlined"
                    label={word[item.key]} // word prop passed to component
                    fullWidth
                    multiline={item.key === "text"}
                    name={item.key}
                    value={item.value}
                    onKeyDown={(e) => handleKeyPress(e)}
                    onChange={(e) => handleChange(e, item, index)}
                    onBlur={() => {
                        const updatedForm = [...form];
                        updatedForm[index].active = false;
                        setForm(updatedForm);
                    }}
                    onFocus={() => {
                        const updatedForm = [...form];
                        updatedForm[index].active = true;
                        setForm(updatedForm);
                    }}
                />
                {
                    !item.valid && (submited || item.active) && (
                        <div className="validation valid-center">
                            {word[item.errorMessage]}
                        </div>
                    )
                }
            </div>
        );
    };
    const renderDropDownField = (item, index) => {

        const optionList = limitData[item.option];
        const defaultValue = getSelected(optionList, item.label);
        const handleDropDownChange = (value) => {
            const updatedForm = [...form];
            updatedForm[index].active = false;

            if (item.key === "repeated_type") {
                updatedForm[index].value = value ? value.value : "";
                updatedForm[index].valid = [1, 2, 3, 4].includes(updatedForm[index].value);
                if (updatedForm[index].value === 1) {
                    updatedForm[index + 1].valid = true;
                }
            } else {
                updatedForm[index].value = value ? value.url : "";
                updatedForm[index].valid = updatedForm[index].value.length > 0;
            }
            setForm(updatedForm);
        };
        const renderError = () => (
            !item.valid && (submitted || item.active) && (
                <div className="validation valid-center">
                    {word[item.errorMessage]}
                </div>
            )
        );

        if (item.key === "repeated_type") {
            return (
                <div key={index} className="input-validation">
                    <Autocomplete
                        options={item.option}
                        getOptionKey={(option) => option.id}
                        defaultValue={defaultValue}
                        getOptionLabel={(option) => word[option.name]}
                        onChange={(e, value) => handleDropDownChange(value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={word[item.key]}
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                    {renderError()}
                </div>
            );
        }

        if (item.key === "manager" || item.key === "accountant") {

            return (
                <div key={index} className="input-validation">
                    <Autocomplete
                        getOptionKey={(option) => option.id}
                        options={optionList || []}
                        value={optionList.find((l) => l.url === item.value) || null}
                        isOptionEqualToValue={(option, value) => option?.url === value?.url}
                        getOptionLabel={(option) =>
                            `${option.user?.first_name || ""} ${option.user?.last_name || ""}`
                        }
                        onChange={(e, value) => handleDropDownChange(value)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={word[item.key]}
                                variant="outlined"
                                fullWidth
                            />
                        )}
                    />
                    {renderError()}
                </div>
            );
        }
        return (

            <div key={index} className="input-validation">
                <Autocomplete
                    options={optionList || []}
                    value={optionList.find((l) => l.url === item.value) || null}
                    isOptionEqualToValue={(option, value) => option?.url === value?.url}
                    loading={!optionList}
                    getOptionKey={(option) => option.id}
                    loadingText={
                        <div className="auto-complete-loader">
                            <Loader type="Oval" color="#101C2A" height={20} width={20}/>
                        </div>
                    }
                    getOptionLabel={(option) => option.name}
                    onChange={(e, value) => handleDropDownChange(value)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={word[item.key]}
                            variant="outlined"
                            fullWidth
                        />
                    )}
                />
                {renderError()}
            </div>
        );

    };
    const renderField = (item, index) =>
        item.type === "dropDown"
            ? renderDropDownField(item, index)
            : renderInputField(item, index, form,);
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{copy ? word.new_recommendations : word.edit_task}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            {form.map((item, index) => renderField(item, index))}

                            <CheckboxFilter
                                title="Տեսանելի բոլորի համար"
                                my_task={visibleForClient}
                                onChange={() => setVisibleForClient(!visibleForClient)}
                            />

                            <div className="img-icon-cont">
                                <div className="img-cont">
                                    {images.map((item, index) =>
                                        index < 4 ? (
                                            <div className="img" key={index}>
                                                <span className="icon-Photos"/>
                                                <span className="images-name">{item.name}</span>
                                            </div>
                                        ) : (
                                            "..."
                                        )
                                    )}
                                </div>
                            </div>

                            <label className="cont">{word.active}
                                <input
                                    type="checkbox"
                                    checked={active}
                                    onChange={() => setActive(!active)}
                                    onKeyDown={handleKeyPress}
                                />
                                <span className="checkmark"/>
                            </label>

                            <div className="line-blue"/>

                            {disabled && (
                                <div className="disable-loader">
                                    <Loader type="Oval" color="#101C2A" height={30} width={30}/>
                                </div>
                            )}

                            <div className="button-line">
                                <BlueButton
                                    disabled={disabled}
                                    buttonStyle={!disabled ? "blue-button" : "blue-button blue-button-disabled"}
                                    title={copy ? word.create : word.edit}
                                    onChangeValue={handleSubmit}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default EditRepeatedTask;